export function getAlignment(index, length) {
    if (index !== length - 1 && index % 2 === 0) {
        return 'left';
    }
    if (index === length - 1) {
        return 'center';
    }
    return 'right';
}
